const META_URL = "/meta.json";

const clearCacheStorage = async () => {
  if (typeof window === "undefined" || !("caches" in window)) {
    return;
  }

  const cacheNames = await window.caches.keys();
  await Promise.all(cacheNames.map(cacheName => window.caches.delete(cacheName)));
};

export const fetchMetaVersion = async () => {
  const response = await fetch(`${META_URL}?t=${Date.now()}`, {
    cache: "no-store"
  });

  if (!response.ok) {
    throw new Error(`Unable to load app metadata (${response.status}).`);
  }

  const meta = await response.json();
  return meta.version;
};

export const refreshApp = async () => {
  try {
    await clearCacheStorage();
  } catch (error) {
    console.error("Unable to clear cache storage before refresh.", error);
  }

  const nextUrl = new URL(window.location.href);
  nextUrl.searchParams.set("_refresh", Date.now().toString());
  window.location.replace(nextUrl.toString());
};
